var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3635_699)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36.2439,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 31.9929C24 30.9155 24.428 29.8822 25.1899 29.1203C25.9517 28.3584 26.9851 27.9304 28.0625 27.9304H36.1875C36.721 27.9304 37.2493 28.0355 37.7422 28.2397C38.235 28.4438 38.6829 28.7431 39.0601 29.1203C39.4374 29.4975 39.7366 29.9454 39.9408 30.4383C40.1449 30.9312 40.25 31.4594 40.25 31.9929V41.3679C40.25 41.9014 40.1449 42.4297 39.9408 42.9226C39.7366 43.4155 39.4374 43.8633 39.0601 44.2405C38.6829 44.6178 38.235 44.917 37.7422 45.1212C37.2493 45.3253 36.721 45.4304 36.1875 45.4304H28.0625C26.9851 45.4304 25.9517 45.0024 25.1899 44.2405C24.428 43.4787 24 42.4454 24 41.3679V31.9929ZM45.5713 43.7904L41.5 40.9804V32.3829L45.5713 29.5717C47.0225 28.5692 49.0025 29.6092 49.0025 31.3717V41.9904C49.0025 43.7529 47.0225 44.7929 45.5713 43.7904Z",
    fill: "#ED8842"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3635_699",
    x: 0.8,
    y: 0.0438967,
    width: 72.4,
    height: 72.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.269963 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3635_699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3635_699",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.cb9d4f986a48e31acb7706e6dad0d4c8.svg";
export { ForwardRef as ReactComponent };